import React from 'react';
import { grayDarkM } from 'web-ui-kit/colors';
var STYLE_VARIANTS = {
  "default": {
    width: '8px',
    height: '13px'
  }
};
var DIRECTIONAL_VARIANTS = {
  left: 0,
  right: 180,
  up: 90,
  down: 270
};

function Arrow(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? undefined : _ref$ariaLabel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? '' : _ref$direction,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? grayDarkM : _ref$color,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'button' : _ref$role;
  var calculatedWidth = variant ? STYLE_VARIANTS[variant]['width'] : STYLE_VARIANTS["default"].width;
  var calculatedHeight = variant ? STYLE_VARIANTS[variant]['height'] : STYLE_VARIANTS["default"].height;
  var calculatedRotation = direction ? DIRECTIONAL_VARIANTS[direction] : DIRECTIONAL_VARIANTS.left;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": ariaLabel,
      className: className,
      width: calculatedWidth,
      height: calculatedHeight,
      viewBox: "0 0 8 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: onClick,
      role: role,
      style: {
        cursor: 'pointer',
        pointerEvents: 'all',
        transform: "rotate(".concat(calculatedRotation, "deg)")
      },
      focusable: role === 'button'
    },
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 1.87054L6.60691 0.5L0 7L6.60691 13.5L8 12.1295L2.78617 7L8 1.87054Z",
      fill: color
    }))
  );
}

export default Arrow;